import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Spinner, Alert } from 'react-bootstrap';
import './login.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { sendPasswordResetOtp } from "./passwordAction";

function Copyright(props) {
  return (
    <p className="mt-3 mb-3" variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <a color='inherit' href='#'>
        Royal Arabian Tours
      </a>{' '}
      {new Date().getFullYear()}
      {'.'}
    </p>
  );
}


export const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const { isLoading, status, message } = useSelector(state => state.passwordReset);
  console.log(status);

  useEffect(() => {
    if (status === "success") {
      navigate("/update-password");
    }
  }, [status, navigate]);

  const handleOnResetSubmit = e => {
    e.preventDefault();
    dispatch(sendPasswordResetOtp(email));
  }

  const handleOnChange = e => {
    const { value } = e.target;
    setEmail(value);
  }

  const validateForm = () => {
    return email.length > 0;
  }

  return (
    <div className="login-container-fluid">
      <Row>
        <Col xs lg="7" className="forgotpassword-bg"><div></div></Col>
        <Col xs lg="5">

          <div className="forgot-second-col">
            <img
              src='/images/RATourlogo.webp'
              srcSet='/images/RATourlogo.webp'
              alt='Royalarabian Tours'
              loading="lazy"
            />
            <ThemeProvider
              breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
              minBreakpoint="xxs"
            >
              <form className=" mt-5" component="form" autoComplete="off" noValidate onSubmit={handleOnResetSubmit}>
                <h4 className="sign-in">Forgot Password?</h4>

                {message && (
                  <Alert variant={status === "success" ? "success" : "danger"}>
                    {message}
                  </Alert>
                )}
                {isLoading && <Spinner variant="primary" animation="border" />}

                <Form.Floating className="mb-3 mt-5">
                  <Form.Control
                    id="floatingInputCustom"
                    autoFocus
                    type="email"
                    value={email}
                    onChange={handleOnChange}
                    placeholder="name@example.com"
                    name="email"
                  />
                  <label htmlFor="floatingInputCustom">Email address</label>
                </Form.Floating>

                <div className="d-grid">
                  <button type="submit" className="btn btn-primary" disabled={!validateForm()}>
                    Reset Password
                  </button>
                </div>
                <p className="forgot-password text-right">
                  Remember <a href="/">Login</a>
                </p>
              </form>
              <hr />
              <br />
              <Copyright />
            </ThemeProvider>
          </div>
        </Col>
      </Row>
    </div>
  );
}
